import React, { Component } from 'react';

export default class DocRow extends Component{
	render(){
	  	const includes = (str) => {
	  		return this.props.RowData.Extension.toLowerCase().includes(str)
	  	}
	  	const icon = () => {
	  		if(includes('do')){
	  			return "fa-file-word-o"
	  		}else if(includes('pdf')){
	  			return "fa-file-pdf-o"
	  		}else if(includes('xl')){
	  			return "fa-file-excel-o"
	  		}else if(includes('txt')){
	  			return "fa-file-text-o"
	  		}else{
	  			return "fa-file-o"
	  		}
	  	};
	  	if (this.props.RowData !== null){ 
		    return(
		    	<div className="col-md-3" >
			        <div className="card card-photo">
			          <div className="card-block img-same-size-wrapper">
			            <div className="text-center"><i className={"fa " + icon() + " fa-5x"}/></div>
			            <div className="text-center world-wrap mt-2">{this.props.RowData.Filename}</div>
			          </div>
			          <div className="overlay"></div>
			          <div className="card-action-center">
			      		<button title="Download this document" className="btn btn-download" onClick={() => this.props.Parent.DownloadDocument(this.props.RowData.Alias, this.props.RowData.Filename)}><i className="fa fa-arrow-circle-o-down"></i></button>{' '}
			      		<button title="Delete this document" className="btn btn-delete-photo" onClick={() => this.props.Parent.DeleteDocument(this.props.RowData.Alias)}><i className="icon-trash"></i></button>
			          </div>
			        </div>
			    </div>
		    )
	  	}else{
	  		return(
	  		    <div className="col-md-12 text-center">
	  		      <div className="card-block align-center NoDataContainer">
	  		        <div>
	  		          <span><i className="fa-5x icon-notebook"></i></span><br/>
	  		          <span><b>No Documents Found</b></span><br/>
	  		        </div>
	  		      </div>
	  		    </div>
	  		)
	  	}
	}
}



// WEBPACK FOOTER //
// ./src/App/asset/document/helper/children/docRow.js